
export default function Installation() {
  const steps = [
    {
      number: '01',
      title: 'Entre em Contato',
      description: 'Fale conosco pelo WhatsApp e informe o modelo do seu veículo',
      icon: 'ri-whatsapp-line'
    },
    {
      number: '02',
      title: 'Agendamento Rápido',
      description: 'Escolha o melhor dia e horário para a instalação',
      icon: 'ri-calendar-check-line'
    },
    {
      number: '03',
      title: 'Instalação Profissional',
      description: 'Técnico certificado realiza a instalação em até 2 horas',
      icon: 'ri-tools-line'
    },
    {
      number: '04',
      title: 'Ativação Imediata',
      description: 'Seu veículo protegido e monitorado instantaneamente',
      icon: 'ri-shield-check-line'
    }
  ];

  return (
    <section id="instalacao" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-yellow-500 text-black px-6 py-2 rounded-full font-bold text-sm mb-6">
            INSTALAÇÃO EXPRESSA
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Instalação em Até 72 Horas
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Processo rápido, simples e sem complicação. Seu veículo protegido em poucos dias!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-gray-50 rounded-xl p-8 h-full border-2 border-gray-200 hover:border-yellow-500 transition-all duration-300 cursor-pointer">
                <div className="text-6xl font-bold text-yellow-500/20 mb-4">
                  {step.number}
                </div>
                <div className="w-14 h-14 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${step.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <i className="ri-arrow-right-line text-3xl text-yellow-500"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl p-10 md:p-12 border border-gray-200">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Instalação Profissional e Garantida
              </h3>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-black"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 text-base">Técnicos Certificados:</strong>
                    <p className="text-gray-600 text-sm">Profissionais treinados e experientes</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-black"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 text-base">Sem Danos ao Veículo:</strong>
                    <p className="text-gray-600 text-sm">Instalação cuidadosa e discreta</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-black"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 text-base">Teste Completo:</strong>
                    <p className="text-gray-600 text-sm">Verificação de todas as funções</p>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-6 h-6 bg-yellow-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-sm text-black"></i>
                  </div>
                  <div>
                    <strong className="text-gray-900 text-base">Treinamento Incluído:</strong>
                    <p className="text-gray-600 text-sm">Aprenda a usar o app e recursos</p>
                  </div>
                </li>
              </ul>
            </div>
            
            <div className="relative">
              <div className="w-full h-80 rounded-xl overflow-hidden shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/9d92bfa9524334a554a4bf02998f9822.jpg"
                  alt="Instalação Profissional"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 bg-yellow-500 rounded-xl p-6 shadow-xl">
                <div className="text-3xl font-bold text-black">72h</div>
                <div className="text-sm font-semibold text-black">Prazo Máximo</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
